import { Box, Fade } from "@mui/material";
import { useEffect, useReducer, useState } from "react";

import Modal from "@mui/material/Modal";

import {
  addKeyvaultVal,
  deleteKeyvaultVal,
  updateConfigVal,
  updateKeyvaultVal,
} from "../../apis/createEnvApi/createEnvApi";
import { useSelector } from "react-redux";
import editIcon from "../../assets/icons/editIcon.svg";
import deleteIcon from "../../assets/icons/deleteIcon.svg";
import closeIcon from "../../assets/icons/closeIcon.svg";
import "./KeyVaultConfigActions.css";
import { useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';


const KeyVaultConfigActions = (params: any) => {
  const { t } = useTranslation();
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );

  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
  const handleCloseEditModal = () => setOpenEditModal(false);

  const [editFormInput, setEditFormInput] = useState<any>({});
  const [secretValue, setSecretValue] = useState(params.item.KeyValue);


  const handleEditSubmit = (event: any) => {
    event.preventDefault();
    console.log("edit DATA--", editFormInput);

    let payload = {
      Emp_Id: EmpId,
      Client_Id: ActiveClient.Client_Id,
      Client_Name: ActiveClient.Client_Name,
      Env_Id: params.selectedEnv.Env_Id,
      Env_Name:params.selectedEnv.Env_Name,
      secretName:params.item.KeyName,
      secretValue:secretValue
    };
    updateKeyvaultVal(payload, async (response: any) => {
      console.log("updateMenu::--", response);
      if (response) {
        params.getAllConfig();
        setOpenEditModal(false);
      }
    });
  };

const handleDeleteKey= ()=>{
  
  let payload = {
    Emp_Id: EmpId,
    Client_Id: ActiveClient.Client_Id,
    Client_Name: ActiveClient.Client_Name,
    Env_Id: params.selectedEnv.Env_Id,
    Env_Name:params.selectedEnv.Env_Name,
    secretName:params.item.KeyName
  };
  deleteKeyvaultVal(payload, async (response: any) => {
    if (response) {
      params.getAllConfig();
      setOpenDeleteConfirmModal(false);
    }
  });
}
   
  return (
    <>
    <div className="actionbtn-div">
        <div onClick={() => setOpenEditModal(true)}>
          <img src={editIcon}/>
        </div>
        <div onClick={() => setOpenDeleteConfirmModal(true)}>
          <img src={deleteIcon} />
        </div>
      </div>

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        className="modal-1"
        aria-labelledby="edit-modal-modal-title"
        aria-describedby="edit-modal-modal-description"
      >
        <Box className="modal-1-box">
          <div className="modal-1-header">
            <div className="modal-1-title">Edit</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                setOpenEditModal(false);
              }}
            >
              <img src={closeIcon} className="icon-md" />
            </div>
          </div>
          <form onSubmit={handleEditSubmit}>
            <div className="model-1-form-body">
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Key Name
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  defaultValue={params.item.KeyName}
                  disabled
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Value
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1"
                  required
                  type="text"
                  defaultValue={params.item.KeyValue}
                  onChange={(e) =>
                    setSecretValue(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="model-1-form-actions center-div">
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
                onClick={() => {
                  setOpenEditModal(false);
                }}
              >
                <div>Cancel</div>
              </button>
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                type="submit"
              >
                <div>Done</div>
              </button>
            </div>
          </form>
        </Box>
      </Modal>


    <Modal
      
      open={openDeleteConfirmModal}
      onClose={() => setOpenDeleteConfirmModal(false)}
      closeAfterTransition

      >
        <Fade 
        in={openDeleteConfirmModal}
        >
        <Box>
            <div className='modal-box logout--modal'>
            <div className="modal--body">
                <div className='modal--wrapper'>
                    <p className='modal--content'>Are you sure you want to Delete "{params.item.KeyName}" key ?</p>
                    <div className="modal--btn logout-modal-btn">
                        <div className='modal--btn--left'>
                            <button onClick={()=>{handleDeleteKey()}} className="confirm-modal-btn">
                            <DoneIcon className='logout_page_icons'  />
                            {t('Yes')}</button>
                        </div>
                        <div className='modal--btn--right'>
                            <button onClick={() => setOpenDeleteConfirmModal(false)} className="confirm-modal-btn">
                                <CloseIcon className='logout_page_icons' />
                                {t('No')}</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default KeyVaultConfigActions;
